import {
	createGettext,
} from 'vue3-gettext';
import translations from './translations.json';

/**
 * Takes a iso639_1 code and converts it to a desired locale
 *
 * @param {string} iso639_1 two letter input code for a language
 * @returns {string} two letters specifying language underscored then two letters specifying locale
 */
export function iso6391ToLocale (iso639_1) { // eslint-disable-line camelcase
	switch(iso639_1) { // eslint-disable-line camelcase
	case 'nl':
		return 'nl_NL'; // eslint-disable-line camelcase
	case 'de':
		return 'de_GE'; // eslint-disable-line camelcase
	case 'fr':
		return 'fr_FR'; // eslint-disable-line camelcase
	case 'es':
		return 'es_ES'; // eslint-disable-line camelcase
	default:
		return 'en_US'; // eslint-disable-line camelcase
	}
}

const getTextPlugin = {
	install: (app) => {
		app.use(createGettext({
			availableLanguages: {
				en_US: 'United States English', // eslint-disable-line camelcase
				nl_NL: 'Netherlands Dutch', // eslint-disable-line camelcase
				de_GE: 'Germany German', // eslint-disable-line camelcase
				fr_FR: 'France French', // eslint-disable-line camelcase
				es_ES: 'Spain Spanish', // eslint-disable-line camelcase
			},
			defaultLanguage: iso6391ToLocale(window.locale),
			translations: translations,
			silent: true,
		}));
	}
};

export default getTextPlugin;
